import { defineQuery, enterQuery, exitQuery } from "bitecs";
import { TagPetComponent } from "../components/TagPetComponent";
import { TagTouchedComponent } from "../components/TagTouchedComponent";
import { TinyPetsWorld } from "../TinyPetsWorld";

export const createPetVibrateSystem = (
    world: TinyPetsWorld,
    config: {}
): {
    petVibrateSystem: (world: TinyPetsWorld) => TinyPetsWorld;
} => {
    const touchedQuery = defineQuery([TagPetComponent, TagTouchedComponent]);
    const touchedEnteredQuery = enterQuery(touchedQuery);
    const touchedExitedQuery = exitQuery(touchedQuery);

    const pattern = [800, 1200];

    let vibrationInterval: NodeJS.Timeout | undefined;

    function startPersistentVibrate(pattern: number[], interval: number) {
        if (vibrationInterval) {
            clearInterval(vibrationInterval);
        }

        navigator.vibrate(pattern);

        vibrationInterval = setInterval(() => {
            navigator.vibrate(pattern);
        }, interval);
    }

    return {
        petVibrateSystem: (world: TinyPetsWorld) => {
            if (touchedEnteredQuery(world).length > 0) {
                startPersistentVibrate(
                    pattern,
                    pattern.reduce((prev, curr) => prev + curr, 0)
                );
            }

            if (touchedExitedQuery(world).length > 0) {
                if (vibrationInterval) {
                    clearInterval(vibrationInterval);
                }
            }

            return world;
        },
    };
};
